module.exports = __webpack_public_path__ + "img/06.f8fe1643.png";